var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadLanding(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#5f00a0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.469 32.373v-5.55c2.441-2.804 3.12-5.462 3.12-8.53 0-4.925-3.527-8.666-9.901-8.666-6.375 0-9.223 4.685-9.223 8.236v2.81c0 .664-.032.666-.141.837-.528.824-1.476 1.911-1.757 2.349-.407.632-1.475 1.411-.61 2.2.118.11 1.347.33 1.51.352.492.068.93.322.93 1.26v2.267c0 .508.582 2.307 2.277 2.003 1.695-.305 7.014-1.124 7.861-1.36.848-.237 1.865-1.049 1.865-2.199V23.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.667 19.431a3.53 3.53 0 1 1-7.06 0 3.53 3.53 0 0 1 7.06 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 21c0 11.046-8.954 20-20 20S1 32.046 1 21 9.954 1 21 1s20 8.954 20 20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadLanding);
export default __webpack_public_path__ + "static/media/head_landing.315796cfbad9df0c19fc077df2ebaa97.svg";
export { ForwardRef as ReactComponent };